import { render } from "./DocumentLineEnter.vue?vue&type=template&id=5055aae9&scoped=true"
const script = {}

import "./DocumentLineEnter.vue?vue&type=style&index=0&id=5055aae9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5055aae9"]])

export default __exports__